export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.1.0',
};
//# sourceMappingURL=buildEnv.js.map